<template>
  <div class="field-wrapper field-wrapper--text field-wrapper--large"
       :class="[field.cssClass, {'visually-hidden': field.visibility === 'hidden'}]">
    <div class="field-group field-group--block"
         :class="[{'field-group--is-error': isError}, {'field-group--block-animated': date}]">
      <label
        class="label"
        :for="'input_' + field.id"
        :class="[{'visually-hidden': field.labelPlacement === 'hidden_label'}]"
      >
        {{ field.label }}<sup v-if="field.isRequired">*</sup>
      </label>

      <flat-pickr
          ref="flatpickr"
          :id="'input_' + field.id"
          :name="'input_' + field.id"
          v-model="date"
          :config="datepickerConfig()"
          class="input-date"
          :required="field.isRequired"
          placeholder="">
      </flat-pickr>
    </div>

    <slot name="description"></slot>
    <slot name="error"></slot>
  </div>
</template>

<script>
import store from '../store';
import VFieldMixins from './VFieldMixins.vue';
import flatPickr from 'vue-flatpickr-component';
import {German} from 'flatpickr/dist/l10n/de.js';
import {Italian} from 'flatpickr/dist/l10n/it.js';

export default {
  store,
  name: "VFieldDate.vue",
  mixins: [VFieldMixins],
  data () {
    return {
      date: '',
      datepickerConfigMinDate: {
        allowInput: true, // enable html5 validation
        onOpen: (selectedDates, dateStr, instance) => {
          instance.altInput.setAttribute("readonly", true)
        },
        onClose: (selectedDates, dateStr, instance) => {
          instance.altInput.setAttribute("readonly", false)
          instance.altInput.blur();
        },
        wrap: true, // set wrap to true only when using 'input-group'
        altFormat: 'd.m.Y',
        altInput: true,
        minDate: new Date().fp_incr(+1),
        dateFormat: 'd.m.Y',
        disableMobile: 'true',
        locale: German, // locale for this instance only
      },
      datepickerConfigMaxDate: {
        allowInput: true, // enable html5 validation
        onOpen: (selectedDates, dateStr, instance) => {
          instance.altInput.setAttribute("readonly", true)
        },
        onClose: (selectedDates, dateStr, instance) => {
          instance.altInput.setAttribute("readonly", false)
          instance.altInput.blur();
        },
        wrap: true, // set wrap to true only when using 'input-group'
        altFormat: 'd.m.Y',
        altInput: true,
        maxDate: new Date().fp_incr(0),
        dateFormat: 'd.m.Y',
        disableMobile: 'true',
        locale: German, // locale for this instance only
      },
    }
  },

  components: {
    flatPickr
  },

  props: {
    formId: Number,
    field: Object,
    fieldKey: Number,
    isError: String
  },

  watch: {
    date: {
      immediate: true,
      deep: false,
      handler (newValue) {
        store.commit(
            'UPDATE_USER_FORM_DATA' ,
            {'key': this.field.id, 'value': newValue})
      }
    }
  },

  methods: {
    datepickerConfig() {
      if (this.field.description === 'maxDate') {
        return this.datepickerConfigMaxDate
      } else {
        return this.datepickerConfigMinDate
      }
    }
  }
}
</script>
